import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=652c4506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652c4506"]])

export default __exports__